/*
 * Info modals controller.
 *
 * One shared shell (#fg-info-modal, from snippets/info-modal-shell.liquid) plus
 * one inert <template data-info-modal-template="ID"> per modal. Clicking any
 * [data-info-modal="ID"] trigger clones the matching template into the shell.
 * The click handler is delegated on document, so it survives the collection
 * grid's AJAX re-renders without re-binding.
 *
 * Template content (including images) stays inert until first cloned, so no
 * modal images are fetched on page load. Cloned fragments are cached so repeat
 * opens are instant.
 */
(function () {
  // Backward-compat guard. While the legacy modal-info.liquid (#infoModal) is
  // still rendered in theme.liquid, let it keep ownership of the autoship
  // trigger so a click can't open two modals at once. Once that {% render
  // 'modal-info' %} line is removed, this controller takes over — including the
  // legacy .autoship-modal-trigger alias below.
  if (document.getElementById('infoModal')) return;

  var shell = document.getElementById('fg-info-modal');
  if (!shell) return;

  var body = shell.querySelector('[data-info-modal-body]');
  var cache = new Map();
  var lastFocused = null;

  function focusable() {
    return shell.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  }

  function open(id) {
    if (!id) return;
    if (!cache.has(id)) {
      var tpl = document.querySelector('template[data-info-modal-template="' + id + '"]');
      if (!tpl) return;
      cache.set(id, tpl.content);
    }
    body.replaceChildren(cache.get(id).cloneNode(true));
    lastFocused = document.activeElement;
    shell.classList.add('fg-info-open');
    shell.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = focusable();
    (f[0] || shell).focus();
  }

  function close() {
    if (!shell.classList.contains('fg-info-open')) return;
    shell.classList.remove('fg-info-open');
    shell.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-info-modal], .autoship-modal-trigger');
    if (trigger) {
      e.preventDefault();
      open(trigger.getAttribute('data-info-modal') || 'autoship');
      return;
    }
    if (e.target.closest('[data-info-modal-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    // Activate role="button" triggers (e.g. lifestyle cards) with Enter/Space.
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      var trigger = e.target.closest('[data-info-modal][role="button"]');
      if (trigger) {
        e.preventDefault();
        open(trigger.getAttribute('data-info-modal'));
        return;
      }
    }

    if (!shell.classList.contains('fg-info-open')) return;
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key === 'Tab') {
      var f = focusable();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
